import { getAsset } from "../utils/utils";
const _zentrakKeys = new Set([
    "921",
    "982A/982B",
    "22",
]);
const _zentrakGeocodes = new Set([
    "478, Rotterdam Europoort 4",
    "525, Amsterdam Singelgracht Aansl.",
    "486, Amsterdam Westhaven (gebied)",
]);
export const isZentrakResult = (key, geocode) => _zentrakKeys.has(key) && _zentrakGeocodes.has(geocode);
export const ZENTRAK_LOGO = getAsset("logo/zentrak-t.png");
